import React from 'react';
import ReactDOM from 'react-dom';
import {toast, Link} from 'acud';
import Cookies from 'js-cookie';
import {getEnv, rawCookies, getInitParams, isLoadByIframe, unescapeHTML, getLoadChannel, ifOauth} from '@/util';
import {LoginType, ThirdType} from '@/constants';
import {
    loginSuccessRedirect,
    renderError,
    showImageCaptcha,
    useSwitchDefaultLoginType,
    changePassPlaceholder,
    changeUCPlaceholder,
    changePassLoginTypeOrder,
    changeUCError,
    changeAgreementPosition,
} from '@/helper';
import {runTest} from '@/abtest/test4';
import UCFootBar from '../FootBar/UCFootBar';
import PASSFootBar from '../FootBar/PASSFootBar';
import QRCodeFootBar from '../FootBar/QRCodeFootBar';
import OtherLoginTypeBar from '../FootBar/OtherLoginTypeBar';
import {bindPASSEvent, bindUCEvent} from './eventHelper';

// window.__inputData__内容为后端传入的数据
window.__inputData__ = window.__inputData__ || skr.features.__inputData__;
const {staticPage, fromu, fromUrl, registerUcLink, redirectUrl, subuserLoginLink, cookieDomain, error} = getInitParams(
    window.__inputData__
);
Cookies.set('__bce-console-referrer__', document.referrer, {domain: cookieDomain});

export function getThirdType(type: ThirdType) {
    if (type === ThirdType.WECHAT_PASSPORT) {
        return 'WECHAT_PASSPORT';
    } else if (type === ThirdType.QQ_PASSPORT) {
        return 'QQ_PASSPORT';
    } else if (type === ThirdType.WEIBO_PASSPORT) {
        return 'WEIBO_PASSPORT';
    }
    return type;
}
// https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/bYw-fpFT3G/wxnrw47kqq/7jzMJqPifNRfr6
export function passportThirdLoginSuccess(data: {thirdType: ThirdType; backUrl: string}) {
    _hmt.push(['_trackPageview', '/virtual/postlogin-pc']);
    Cookies.set('bce-login-type', 'PASSPORT', {domain: cookieDomain, sameSite: 'None', secure: true});
    localStorage && localStorage.setItem('bce-last-login-type', 'PASSPORT');
    Cookies.set('bce-login-type-detail', getThirdType(data.thirdType), {
        domain: cookieDomain,
        sameSite: 'None',
        secure: true,
    });
    rawCookies.set('x-bce-login-redirect-url', redirectUrl, {domain: cookieDomain});
    // 供后端区分来源是否为iframe
    if (isLoadByIframe()) {
        Cookies.set('bce-fe-load-type', 'iframe', {domain: cookieDomain});
    }
    // iframe登录先不要设置这个cookie，会导致新页面正常登录重定向到错误的页面
    else {
        Cookies.set('bce-fe-load-type', 'self', {domain: cookieDomain});
        rawCookies.set('x-bce-login-redirect-url-console', redirectUrl, {domain: cookieDomain});
    }
    // window.parent && window.parent.postMessage({iframeUrl: location.href}, '*');
    // passport三方登录成功后需要业务方自行跳转
    loginSuccessRedirect(data.backUrl);
}

export function passportSDKErrorHandler(error: {message?: string}) {
    if (error.message === 'passport is not defined') {
        if (getEnv() === 'SANDBOX') {
            toast.error({
                message: '沙盒环境PASSPORT JS SDK 加载失败',
                description: (
                    <>
                        请参考
                        <Link
                            href="https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/pKzJfZczuc/rUkPar4o8W/SEXGa31l6i5Jat"
                            target="_blank"
                        >
                            公有云IAM的FAQ
                        </Link>
                        第九条解决
                    </>
                ), // eslint-disable-line
            });
        } else if (getEnv() === 'ONLINE') {
            _hmt.push(['_trackEvent', 'js-sdk-error', 'passport']);
            toast.error({
                message: 'PASSPORT JS SDK 加载失败',
                description: (
                    <>
                        请至
                        <Link href="https://passport.baidu.com/v2/?ucenterfeedback#login" target="_blank">
                            帮助中心
                        </Link>
                        反馈
                    </>
                ), // eslint-disable-line
            });
        }
    }
}

export function initPass() {
    return new Promise((resolve, reject) => {
        try {
            passport.use(
                'login',
                {
                    tangram: true,
                    loginVersion: 'v5',
                    defaultCss: true,
                },
                (magic: any) => {
                    // eslint-disable-next-line
                    const passLogin = new magic.passport.login({
                        // https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/pKzJfZczuc/dPhc3scHyC/lJgz1JflV04-2J
                        // https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/pKzJfZczuc/x3oru0uU3V/V7CjWhBz-KSNqH
                        product: 'bceplat',
                        loginType: 1,
                        loginMerge: true, // 是否合并
                        hasRegUrl: false, // 是否有注册链接
                        autosuggest: true, // 是否自动提示
                        hasPlaceholder: true, // 是否有placeholder
                        authsiteLogin: ['weixin', 'qzone', 'tsina'], // 第三方登录
                        u: fromu,
                        isPhone: false,
                        safeFlag: 0,
                        sms: 5,
                        staticPage,
                        memberPass: true,
                        guideMapImg: 'https://passport.qatest.baidu.com/passApi/img/qrcodeLoginGuide1.png', // 新增配置的引导图
                        qrcodeCfg: {
                            // 展示处文案 如 请使用百度APP扫码登录
                            // 其实在下面被QRCodeFootBar覆盖了，但是appTitle必须传个东西，不然SDK会按照默认样式展示
                            appTitle: '使用百度智能云APP/百度APP扫码登录',
                        },
                        // 是否展示百度logo
                        hideLogo: 1,
                        composeTemplate: 1,
                        bannerImage: '',
                        canMessageChannel: 1, // 三方登录后增加回调通知postMessage，且不会自动跳转登录成功跳转的目标地址
                        showAgreeCheckbox: 1,
                    });
                    passLogin.on('render', (options: any) => {
                        $('#componseLeft').append('<div id="qrcode-foot-bar"></div>');
                        $('#componseRight .pass-form-normal').append('<div id="pass-foot-bar-normal"></div>');
                        $('#componseRight .tang-pass-sms').append('<div id="pass-foot-bar-sms"></div>');
                        const $sepLine = $('<div id="pass-vertical-separate-line"></div>');
                        $('#componseRight').after($sepLine);
                        $sepLine.after($('#componseLeft'));
                        ReactDOM.render(<QRCodeFootBar />, document.querySelector('#qrcode-foot-bar'));
                        ReactDOM.render(
                            <PASSFootBar
                                fromu={fromu}
                                registerUcLink={registerUcLink}
                                subuserLoginLink={subuserLoginLink}
                            />,
                            document.querySelector('#pass-foot-bar-normal')
                        );
                        ReactDOM.render(
                            <PASSFootBar
                                fromu={fromu}
                                registerUcLink={registerUcLink}
                                subuserLoginLink={subuserLoginLink}
                            />,
                            document.querySelector('#pass-foot-bar-sms')
                        );
                        ReactDOM.render(
                            <OtherLoginTypeBar loginType={LoginType.PASSPORT} />,
                            document.querySelector('#other-login-bar-pass')
                        );

                        bindPASSEvent(options, getLoadChannel());
                        changePassLoginTypeOrder();
                        useSwitchDefaultLoginType(options, getLoadChannel());
                        $('#TANGRAM__PSP_4__changePwdCodeItem').text('账号登录');
                        changePassPlaceholder();
                        renderError(error);
                        changeAgreementPosition();
                        // 下面是执行ABTest相关的逻辑
                        runTest();
                        resolve('');
                    });
                    passLogin.on('loginSuccess', (e: any) => {
                        // FIXME: e?.rsp?.loginType这个字段目前passport未提供文档，debug自己猜的
                        const loginType = e?.rsp?.loginType;
                        _hmt.push(['_trackPageview', '/virtual/postlogin-pc']);
                        Cookies.set('bce-login-type', 'PASSPORT', {
                            domain: cookieDomain,
                            sameSite: 'None',
                            secure: true,
                        });
                        localStorage && localStorage.setItem('bce-last-login-type', 'PASSPORT');
                        if (loginType === 'sms') {
                            Cookies.set('bce-login-type-detail', LoginType.SMS_PASSPORT, {
                                domain: cookieDomain,
                                sameSite: 'None',
                                secure: true,
                            });
                        } else if (loginType === 'password') {
                            Cookies.set('bce-login-type-detail', LoginType.NORMAL_PASSPORT, {
                                domain: cookieDomain,
                                sameSite: 'None',
                                secure: true,
                            });
                        } else {
                            Cookies.set('bce-login-type-detail', LoginType.QRCODE_PASSPORT, {
                                domain: cookieDomain,
                                sameSite: 'None',
                                secure: true,
                            });
                        }
                        rawCookies.set('x-bce-login-redirect-url', redirectUrl, {domain: cookieDomain});
                        // 供后端区分来源是否为iframe
                        if (isLoadByIframe()) {
                            Cookies.set('bce-fe-load-type', 'iframe', {domain: cookieDomain});
                        }
                        // iframe登录先不要设置这个cookie，会导致新页面正常登录重定向到错误的页面
                        else {
                            Cookies.set('bce-fe-load-type', 'self', {domain: cookieDomain});
                            rawCookies.set('x-bce-login-redirect-url-console', redirectUrl, {domain: cookieDomain});
                        }
                        // window.parent && window.parent.postMessage({iframeUrl: location.href}, '*');
                    });
                    passLogin.render('pass-login');
                }
            );
        } catch (error: any) {
            passportSDKErrorHandler(error);
            reject(error);
        }
    });
}

export function initUC() {
    return new Promise((resolve, reject) => {
        // http://wiki.baidu.com/pages/viewpage.action?pageId=847807789
        try {
            ucCommonLogin.init({
                container: 'login',
                appid: 285,
                AUTO: 0,
                defaultCss: 0,
                appscope: [3, 6, 12, 223, 285],
                staticPage,
                multiLogin: false,
                isSmall: 1,
                isLayer: 0,
                fromu: unescapeHTML(fromUrl),
                product: 'bceplat',
                registerUcLink: registerUcLink,
                ucTip: '',
                success(opts: any) {
                    _hmt.push(['_trackPageview', '/virtual/postlogin-pc']);
                    localStorage && localStorage.setItem('bce-last-login-type', 'UC');
                    Cookies.set('bce-login-type', opts.type.toUpperCase(), {
                        domain: cookieDomain,
                        sameSite: 'None',
                        secure: true,
                    });
                    Cookies.set('bce-login-type-detail', LoginType.UC, {
                        domain: cookieDomain,
                        sameSite: 'None',
                        secure: true,
                    });
                    rawCookies.set('x-bce-login-redirect-url', redirectUrl, {domain: cookieDomain});
                    // 供后端区分来源是否为iframe
                    if (isLoadByIframe()) {
                        Cookies.set('bce-fe-load-type', 'iframe', {domain: cookieDomain});
                    }
                    // iframe登录先不要设置这个cookie，会导致新页面正常登录重定向到错误的页面
                    else {
                        Cookies.set('bce-fe-load-type', 'self', {domain: cookieDomain});
                        rawCookies.set('x-bce-login-redirect-url-console', redirectUrl, {domain: cookieDomain});
                    }
                    // window.parent && window.parent.postMessage({iframeUrl: location.href}, '*');
                    loginSuccessRedirect(fromu);
                },
                rendered() {
                    // 某些情况sdk渲染会带上uc-common-login这个class，样式会错乱，所以统一去掉
                    // $('#login').removeClass('uc-common-login');
                    ReactDOM.render(
                        <UCFootBar registerUcLink={registerUcLink} subuserLoginLink={subuserLoginLink} />,
                        document.querySelector('.other .fr')
                    );
                    if (!ifOauth()) {
                        ReactDOM.render(
                            <OtherLoginTypeBar loginType={LoginType.UC} />,
                            document.querySelector('#other-login-bar-uc')
                        );
                    }
                    renderError(error);
                    // 本地调试图片验证码样式
                    if (skr.features.showUCImageCaptcha) {
                        showImageCaptcha(3);
                    }
                    bindUCEvent(getLoadChannel());
                    resolve('');
                    changeUCPlaceholder();
                    changeUCError();
                },
            });
        } catch (error: any) {
            if (error.message === 'ucCommonLogin is not defined') {
                if (getEnv() === 'SANDBOX') {
                    toast.error({
                        message: '沙盒环境UC JS SDK 加载失败',
                        description: <>请至如流群1652027反馈</>,
                    });
                } else if (getEnv() === 'ONLINE') {
                    _hmt.push(['_trackEvent', 'js-sdk-error', 'uc']);
                    toast.error({
                        message: 'UC JS SDK 加载失败',
                        description: <>请提工单反馈</>,
                    });
                }
            }
            reject(error);
        }
    });
}
